<template>
  <div>
    <div class="border">
      <purchases :id="order.id"  :order="order"/>
      <promotions :order="order" :partner="partner" />
    </div>

    <button @click="send" class="btn btn-info mw mt-4">
      <span v-if="!transaction">{{
        "create_prder" | setText("Создать заказ")
      }}</span>
      <span v-else>{{ "next_step" | setText("") }}</span>
    </button>
  </div>
</template>
<script>
import { logger, errorNotify } from "../../../plugins/functions";
import Purchases from "@/components/Item/Order/Purchases";
import Promotions from "@/components/Item/Order/Promotions";
export default {
  components: {
    Purchases,
    Promotions,
  },
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    transaction: {
      default: function () {
        return null;
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    updateOrder: {
      default: function () {},
    },
    value: {
      default: function () {},
    },
    createTransaction: {
      default: function () {},
    },
  },
  name: "filter",
  async created() {},
  methods: {
    send() {
      if (!this.order.purchases || !this.order.purchases.length) {
        this.$notify({
          title: `!!!`,
          message: "Установите хотябы 1 товар",
          icon: "ti-close",
          horizontalAlign: "right",
          verticalAlign: "top",
        });

        return false;
      }
      //Создание заказа
      this.createTransaction({
        step: "processing",
      });

      this.$emit("setStep", "processing");
    },
  },
  data() {
    return {
      data: {},
    };
  },
};
</script>

